export default {
  name: 'FundPage',

  data() {
    return {
      activeFaq: null,

      stats: [
        { value: '12+', labelKey: 'fund.statEA' },
        { value: '30–36%', labelKey: 'fund.statProfit' },
        { value: '≤ 30%', labelKey: 'fund.statDrawdown' },
        { value: '24/7', labelKey: 'fund.statAuto' },
      ],

      overviewItems: [
        {
          icon: 'fas fa-robot',
          titleKey: 'fund.ov1Title',
          descKey: 'fund.ov1Desc',
        },
        {
          icon: 'fas fa-shield-alt',
          titleKey: 'fund.ov2Title',
          descKey: 'fund.ov2Desc',
        },
        {
          icon: 'fas fa-chart-line',
          titleKey: 'fund.ov3Title',
          descKey: 'fund.ov3Desc',
        },
        {
          icon: 'fas fa-users',
          titleKey: 'fund.ov4Title',
          descKey: 'fund.ov4Desc',
        },
      ],

      steps: [
        { titleKey: 'fund.step1Title', descKey: 'fund.step1Desc' },
        { titleKey: 'fund.step2Title', descKey: 'fund.step2Desc' },
        { titleKey: 'fund.step3Title', descKey: 'fund.step3Desc' },
        { titleKey: 'fund.step4Title', descKey: 'fund.step4Desc' },
      ],

      riskRows: [
        {
          icon: 'fas fa-percentage',
          labelKey: 'fund.risk1Label',
          value: '30–36%',
          noteKey: 'fund.risk1Note',
          featured: true,
        },
        {
          icon: 'fas fa-arrow-down',
          labelKey: 'fund.risk2Label',
          value: '≤ 30%',
          noteKey: 'fund.risk2Note',
          featured: false,
        },
        {
          icon: 'fas fa-trophy',
          labelKey: 'fund.risk3Label',
          value: '> 65%',
          noteKey: 'fund.risk3Note',
          featured: false,
        },
        {
          icon: 'fas fa-coins',
          labelKey: 'fund.risk4Label',
          value: '10M VNĐ',
          noteKey: 'fund.risk4Note',
          featured: false,
        },
        {
          icon: 'fas fa-hand-holding-usd',
          labelKey: 'fund.risk5Label',
          value: '10%',
          noteKey: 'fund.risk5Note',
          featured: false,
        },
      ],

      faqs: [
        { qKey: 'fund.faq1Q', aKey: 'fund.faq1A' },
        { qKey: 'fund.faq2Q', aKey: 'fund.faq2A' },
        { qKey: 'fund.faq3Q', aKey: 'fund.faq3A' },
        { qKey: 'fund.faq4Q', aKey: 'fund.faq4A' },
        { qKey: 'fund.faq5Q', aKey: 'fund.faq5A' },
      ],
    };
  },

  methods: {
    toggleFaq(i) {
      this.activeFaq = this.activeFaq === i ? null : i;
    },
    goToContact() {
      this.$router.push('/contact');
    },
  },
};
